import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Routing } from "./Routes";

// Manual cache clearing helper
const useClearBrowserCache = () => {
  useEffect(() => {
    const clearCache = () => {
      try {
        // Clear service worker cache
        if (typeof window !== 'undefined' && 'caches' in window) {
          caches.keys().then(cacheNames => {
            cacheNames.forEach(cacheName => {
              caches.delete(cacheName);
            });
          }).catch(err => console.warn('Error clearing cache:', err));
        }
        
        // Clear localStorage if needed
        if (typeof localStorage !== 'undefined') {
          // Keep essential items, clear others
          const keysToKeep = ['access_token', 'refresh_token', 'persist:root'];
          Object.keys(localStorage).forEach(key => {
            if (!keysToKeep.includes(key)) {
              localStorage.removeItem(key);
            }
          });
        }
      } catch (error) {
        console.warn('Error clearing browser cache:', error);
      }
    };

    // Clear cache on app load
    clearCache();
  }, []);
};

export default function App({ basename }) {
  useClearBrowserCache();

  return (
    <BrowserRouter basename={basename}>
      {/* Render routes with provided `Layout`. */}
      <Routing />
    </BrowserRouter>
  );
}
